import React from "react";

import classNames from "classnames";
import {observer} from 'mobx-react';
import {ShotMapBallRequestParams} from "../../../../core/icons/shot-map/shot-map.ball.request-params";
import {useThemeColor} from "../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../core/app/consts/colors";
import {SVGImage} from "../../../../core/components/image/svg-image";
import {THEME} from "../../../../core/app/consts";

export const GameShotChartWidgetFootballShot = observer(({
                                                           controller,
                                                           selectedShot,
                                                           shot,
                                                           color,
                                                           classNameCourt,
                                                           classNameShot,
                                                           onClick,
                                                           lineOffset,
                                                           sideOffset
                                                         }) => {
  const {device} = controller;
  const {isRtl} = device;
  const className = classNames(classNameCourt, classNameShot)
  const isSelectedShot: Boolean = selectedShot?.key === shot?.key;

  const shotStyle = {
    [shot.isHomeCompetitor ? isRtl ? 'left' : 'right' : isRtl ? 'right' : 'left']: parseInt(shot.side * sideOffset),
    [shot.isHomeCompetitor ? isRtl ? 'bottom' : 'top' : isRtl ? 'top' : 'bottom']: parseInt(shot.line * lineOffset),
  }

  const shotZindex: Number = isSelectedShot ? 3 : shot.isGoalType ? 2 : 1
  const shotContainerProps = {
    className,
    style: {
      borderColor: color,
      backgroundColor: useThemeColor(COLORS.surfaceSecondary, THEME.LIGHT),
      zIndex: shotZindex,
      opacity: isSelectedShot ? 1 : 0.8,
      ...shotStyle,
    }
  }

  const imageContainerProps = {
    className,
    onClick: () => onClick(shot),
    style: {
      zIndex: shotZindex,
      backgroundColor: useThemeColor(COLORS.surfaceSecondary, THEME.LIGHT),
      borderColor: color,
      borderWidth: 1,
      opacity: isSelectedShot ? 1 : 0.8,
      ...shotStyle
    }
  }

  const imageProps = {
    src: new ShotMapBallRequestParams(),
    fillcolor: useThemeColor(shot.isOwnGoalShot ? COLORS.dangerPrimary : COLORS.textPrimary, THEME.LIGHT),
    style: {
      width: 10,
      height: 10
    }
  }

  return shot.isGoalType ? <div {...imageContainerProps}>
    <SVGImage {...imageProps}/>
  </div> : <div {...shotContainerProps} onClick={() => onClick(shot)}/>
});
